"use client";

import React from "react";

interface LoginDropdownProps {
  variant?: "button" | "text";
  primaryColor?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export default function LoginDropdown({
  variant = "button",
  primaryColor = "#3B82F6",
  className = "",
  style,
  onClick,
}: LoginDropdownProps) {
  if (variant === "text") {
    return (
      <a
        href="/login"
        className={`flex items-center gap-1 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors ${className}`}
        style={style}
        onClick={onClick}
      >
        Login
      </a>
    );
  }
  
  return (
    <a
      href="/login"
      className={`inline-flex items-center justify-center gap-2 rounded-full px-4 sm:px-6 py-2 sm:py-2.5 text-xs sm:text-sm font-bold text-white shadow-md transition-all hover:shadow-lg hover:-translate-y-0.5 whitespace-nowrap ${className}`}
      style={{
        background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)`,
        ...style,
      }}
      onClick={onClick}
    >
      Login
    </a>
  );
}